import axios from 'axios'

const competencias = {
    state: () => ({
        competencias: [],
        competencia: {},

        competenciasWorldSkills: [],
        competenciaWorldSkills: {},

        documentos: [],
        documento: {},

        competenciasCampesena: [],
        competenciaCampesena:{}
    }),
    
    getters: {
        obtenerCompetencias(state) {
            return state.competencias
        },

        obtenerCompetencia(state) {
            return state.competencia
        },

        obtenerCompetenciasWorldSkills(state) {
            return state.competenciasWorldSkills
        },

        obtenerCompetenciaWorldSkills(state) {
            return state.competenciaWorldSkills
        },

        obtenerDocumentosCompetencias(state) {
            return state.documentos
        },

        obtenerDocumentoCompetencia(state) {
            return state.documento
        },

        obtenerCompetenciasCampesena(state) {
            return state.competenciasCampesena
        },
        
        obtenerCompetenciaCampesena(state) {
            return state.competenciaCampesena
        },
    },

    mutations: {
        enviarCompetencias(state, competencias) {
            state.competencias = competencias
        },

        enviarCompetencia(state, competencia) {
            state.competencia = competencia
        },


        enviarCompetenciasWorldSkills(state, competencia) {
            state.competenciasWorldSkills = competencia
        },

        enviarCompetenciaWorldSkills(state, competencia) {
            state.competenciaWorldSkills = competencia
        },
        

        enviarDocumentosCompetencias(state, documentos) {
            state.documentos = documentos
        },

        enviarDocumentoCompetencia(state, documento) {
            state.documento = documento
        },
        

        enviarCompetenciasCampesena(state, competencias) {
            state.competenciasCampesena = competencias
        },
        
        enviarCompetenciaCampesena(state, competencia) {
            state.competenciaCampesena = competencia
        },
    },

    actions: {
        registrarCompetencia(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.post("api/competencias", competencia)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        gestionarCompetencias(context) {
            axios.get("api/competencias")
            .then((response) => {
                const competencias = []

                response.data.results.forEach(competencia => {
                    competencias.push({
                        id:                     competencia.id_competencia,
                        centro_formacion_id:    competencia.centro_formacion.id_centro_formacion, 
                        centro_formacion:       competencia.centro_formacion.centro_formacion, 
                        fecha_inicio:           competencia.fecha_inicio,
                        fecha_fin:              competencia.fecha_fin,
                        competencia:            competencia.competencia,
                        descripcion:            competencia.descripcion,
                        lugar:                  competencia.lugar,
                        direccion:              competencia.direccion
                    })
                });

                context.commit("enviarCompetencias", competencias)
            })
            .catch(() => {})
        },

        detallesCompetencia(context, competencia) {
            axios.get("api/competencias/"+competencia)
            .then((response) => {
                const detalles = response.data.results

                const competencia =  {
                    id:                     detalles.id_competencia,
                    regional_id:            detalles.centro_formacion.regional.id_regional, 
                    regional:               detalles.centro_formacion.regional.regional, 
                    centro_formacion_id:    detalles.centro_formacion.id_centro_formacion, 
                    centro_formacion:       detalles.centro_formacion.centro_formacion, 
                    fecha_inicio:           detalles.fecha_inicio,
                    fecha_fin:              detalles.fecha_fin,
                    competencia:            detalles.competencia,
                    descripcion:            detalles.descripcion,
                    lugar:                  detalles.lugar,
                    direccion:              detalles.direccion
                }

                context.commit("enviarCompetencia", competencia)
            })
            .catch(() => {})
        },

        editarCompetencia(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.get("api/competencias/"+competencia+"/editar")
                .then((response) => {
                    resolve(response.data.results)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        actualizarCompetencia(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.put("api/competencias/"+competencia.id, competencia)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        registrarCompetenciaWorldSkills(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.post("api/competenciasWorldSkills", competencia)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },
        
        gestionarCompetenciasWorldSkills(context) {
            axios.get("api/competenciasWorldSkills")
            .then((response) => {
                const competenciasWorldSkills = []

                response.data.results.forEach((response) => {
                    competenciasWorldSkills.push({
                        id:                     response.id_competencia,
                        centro_formacion_id:    response.centro_formacion.id_centro_formacion, 
                        centro_formacion:       response.centro_formacion.centro_formacion, 
                        regional_id:            response.centro_formacion.regional.id_regional, 
                        regional:               response.centro_formacion.regional.regional,
                        tipo_competencia_id:    response.tipo_competencia.id_tipo_competencia,
                        tipo_competencia:       response.tipo_competencia.tipo_competencia,
                        competencia_id:         response.competencia_id, 
                        competencia:            response.competencia,
                        fecha_inicio:           response.fecha_inicio,
                        fecha_fin:              response.fecha_fin,
                        descripcion:            response.descripcion,
                        lugar:                  response.lugar,
                        direccion:              response.direccion
                    })
                });

                context.commit("enviarCompetenciasWorldSkills", competenciasWorldSkills)
            })
            .catch(() => {})
        },

        detalleCompetenciaWorldSkills(context, competencia) {
            axios.get("api/competenciasWorldSkills/"+competencia)
            .then((response) => {
                let respuesta = response.data.results

                const sedes = []
                respuesta.competencia_sede.forEach((res) => { 
                    sedes.push({
                        sede: res.sede.sede
                    })
                })
                
                const competenciaWorldSkills = {
                    id:                     respuesta.id_competencia,
                    centro_formacion_id:    respuesta.centro_formacion.id_centro_formacion, 
                    centro_formacion:       respuesta.centro_formacion.centro_formacion, 
                    regional_id:            respuesta.centro_formacion.regional.id_regional, 
                    regional:               respuesta.centro_formacion.regional.regional,
                    tipo_competencia_id:    respuesta.tipo_competencia.id_tipo_competencia,
                    tipo_competencia:       respuesta.tipo_competencia.tipo_competencia,
                    competencia_id:         respuesta.competencia_id, 
                    competencia:            respuesta.competencia,
                    fecha_inicio:           respuesta.fecha_inicio,
                    fecha_fin:              respuesta.fecha_fin,
                    descripcion:            respuesta.descripcion,
                    lugar:                  respuesta.lugar,
                    direccion:              respuesta.direccion,
                    sedes:                  sedes
                }
                
                context.commit("enviarCompetenciaWorldSkills", competenciaWorldSkills)
            })
            .catch(() => {})
        },

        editarCompetenciaWorldSkills(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.get("api/competenciasWorldSkills/"+competencia)
                .then((response) => {
                    resolve(response.data.results)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        actualizarCompetenciaWorldSkills(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.put("api/competenciasWorldSkills/"+competencia.id_competencia, competencia)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        registrarDocumentoCompetencia(context, documento) {
            return new Promise((resolve, reject) => {
                axios.post("api/competencias/"+documento.get("competencia_id")+"/documentos", documento, { headers: {'Content-Type': 'multipart/form-data'}})
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        gestionarDocumentosCompetencia(context, competencia){
            axios.get(`api/competencias/${competencia}/documentos`)
            .then((response) => {
                const documentos = []
                
                response.data.results.forEach(documento => {
                    documentos.push({
                        id:                 documento.id_documento_competencia,
                        nombre_documento:   documento.nombre_documento,
                        competencia_id:     documento.competencia_id
                    }); 
                });

                context.commit("enviarDocumentosCompetencias", documentos)
            })
        },

        eliminarDocumentoCompetencia(context, documento) {
            return new Promise((resolve, reject) => {
                axios.delete(`api/competencias/${documento.competencia_id}/documentos/${documento.id_documento_competencia}`)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        descargarDocumentoCompetencia(context, documento){
            return new Promise((resolve, reject) => {
               axios.get(`api/competencias/documentos/descargar/${documento}`, { responseType: 'blob' })
                .then((response) => {
                    resolve(response)
                })
                .catch(() => {
                    reject()
                })
            })        
        },


        //campesena 
        registrarCompetenciacampesena(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.post("api/campesena/competencias", competencia)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        gestionarCompetenciasCampesena(context) {
            axios.get("api/campesena/competencias")
            .then((response) => {
                const competencias = [];
        
                response.data.results.forEach(competencia => {
                    competencias.push({
                        id:                     competencia.id_competencia,
                        centro_formacion_id:    competencia.centro_formacion.id_centro_formacion,
                        centro_formacion:       competencia.centro_formacion.centro_formacion,
                        competencia:            competencia.competencia.charAt(0).toUpperCase() + competencia.competencia.slice(1),
                        fecha_inicio:           competencia.fecha_inicio,
                        fecha_fin:              competencia.fecha_fin,
                        descripcion:            competencia.descripcion,
                        lugar:                  competencia.lugar,
                        direccion:              competencia.direccion
                    });
                });
        
                context.commit("enviarCompetenciasCampesena", competencias);
            })
            .catch(() => {});
        },

        obtenerCompetenciaCampesenaId(context, competenciaId) {
            return new Promise((resolve, reject) => {
                axios.get(`api/campesena/competencias/${competenciaId}`)
                .then((response) => {
                    const results= response.data.results
                    const competencia ={
                        id:                     results.id_competencia,
                        regional_id:            results.centro_formacion.regional.id_regional,
                        centro_formacion_id:    results.centro_formacion.id_centro_formacion,
                        centro_formacion:       results.centro_formacion.centro_formacion,
                        competencia:            results.competencia.charAt(0).toUpperCase() + results.competencia.slice(1),
                        fecha_inicio:           results.fecha_inicio,
                        fecha_fin:              results.fecha_fin,
                        descripcion:            results.descripcion,
                        lugar:                  results.lugar,
                        direccion:              results.direccion
                    }
        
                    context.commit('enviarCompetenciaCampesena', competencia) 
                    resolve(response.data.results)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        actualizarCompetenciaCampesena(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.put("api/campesena/competencias/"+competencia.id, competencia)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },
    }
}

export default competencias